import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Autoplay,
  Pagination,
  Navigation,
  EffectFade,
} from "swiper/modules";

import { Link } from "react-router-dom";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

import "./SwiperNacio.css";
import PageLoader from "../components/PageLoader";

export default function SwiperNacio() {
  const [posts, setPosts] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  const [isLoading, setIsLoading] = useState(true);
  const [loaderDone, setLoaderDone] = useState(false);
  const [loadedImages, setLoadedImages] = useState(0);

  useEffect(() => {
    fetch("https://carboncro.hr/wp-json/wp/v2/posts?categories=27&_embed")
      .then((res) => res.json())
      .then((data) => {
        setPosts(data);

        // Ako nema slika/postova ugasi loader
        if (!data.length) {
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.error("Greška pri dohvatu slidera:", err);
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    if (posts.length > 0 && loadedImages >= posts.length) {
      setIsLoading(false);
    }
  }, [loadedImages, posts]);

  return (
    <>
      {!loaderDone && (
        <PageLoader
          isReady={!isLoading}
          onHide={() => setLoaderDone(true)}
        />
      )}

      {posts.length > 0 && (
        <div className="tesla-hero">
          <Swiper
            effect="fade"
            modules={[Autoplay, Pagination, Navigation, EffectFade]}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
              el: ".swiper-pagination",
            }}
            navigation={true}
            loop={posts.length > 1}
            onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
            onInit={(swiper) => {
              setTimeout(() => {
                if (swiper.navigation) {
                  swiper.navigation.prevEl =
                    swiper.el.querySelector(".swiper-button-prev");
                  swiper.navigation.nextEl =
                    swiper.el.querySelector(".swiper-button-next");
                  swiper.navigation.init();
                  swiper.navigation.update();
                }
              }, 100);
            }}
          >
            {posts.map((post, i) => {
              const image =
                post._embedded?.["wp:featuredmedia"]?.[0]?.source_url || "";

              const active = i === activeIndex;

              const route = post.acf?.ruta
                ? post.acf.ruta.startsWith("/")
                  ? post.acf.ruta
                  : `/${post.acf.ruta}`
                : "/galerija";

              return (
                <SwiperSlide key={post.id}>
                  <div className="tesla-slide">
                    <img
                      src={image}
                      className={`tesla-img ${active ? "active" : ""}`}
                      alt={post.title.rendered}
                      onLoad={() =>
                        setLoadedImages((prev) => prev + 1)
                      }
                      onError={() =>
                        setLoadedImages((prev) => prev + 1)
                      }
                    />

                    <div className="tesla-overlay" />

                    <div
                      className={`tesla-content ${
                        active ? "show" : ""
                      }`}
                    >
                      <h1
                        dangerouslySetInnerHTML={{
                          __html: post.title.rendered,
                        }}
                      />

                      <p
                        dangerouslySetInnerHTML={{
                          __html: post.content.rendered,
                        }}
                      />

                      <Link to={route}>
                        <button className="hero-btn">
                          {post.acf?.tekst_gumba ||
                            "Pogledaj ponudu"}
                        </button>
                      </Link>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      )}
    </>
  );
}